module.exports = __webpack_public_path__ + "img/icon-apple.e5eb474a.png";